import {
  RESET_JOBS,
  SET_ACTIVE_JOB,
  ADD_MESSAGE_TO_JOB,
  ADD_MESSAGE_TO_JOB_BY_PROTOCOL,
  REMOVE_JOB_FROM_LIST,
  ADD_TAG_TAGS_ATTENDANCE,
  REMOVE_TAG_TAGS_ATTENDANCE,
  NEW_MESSAGE_NOT_READ,
  ALTER_FIELD_SCRIPT,
  UPDATE_ACTIVE_JOB,
  UPDATE_STATUS_MESSAGE,
  SET_NOTIFICATIONS_ACTIVEJOB,
  SET_HISTORY_ACTIVE_JOB,
  SET_MESSAGES_FROM_HISTORY,
  CLEAR_CONTACT_HISTORY,
  UPDATE_JOB_CONTACT,
  UPDATE_JOB_CONTACT_COLUMNS,
  UPDATE_JOB,
  FORCE_UPDATE_JOB,
  CLEAR_PROTOCOL,
  SET_JOB_TIMES_INFORMATIONS_COMMUNICATOR,
  DELETE_MANUAL_ACTIVATION,
  ADD_MESSAGES_HISTORY_JOB,
  INCREMENT_PAGE_HISTORY_MESSAGE,
  UPDATE_MESSAGE_JOB_BY_CUSTOM_ID,
  ADD_LAST_CONTACT,
  DISABLE_CONVERSATION_TAB,
  ENABLE_CONVERSATION_TAB,
  DISABLE_CONVERSATION_OPTIONS,
  ENABLE_CONVERSATION_OPTIONS,
  ENABLE_JOB_TEMPLATE_CONVERSATION,
  DISABLE_JOB_TEMPLATE_CONVERSATION,
  SET_TRANSFER_ASSISTED,
  SET_TRANSFER_ASSISTED_ACCEPTED,
  SET_WHATSAPP_KEEP_ALIVE,
  SET_NEW_WHATSAPP_MESSAGE_NOTIFICATION,
  SET_WHATSAPP_TEMPLATE_SENT,
  SET_ACK_CALL_REQUEST_DIALOG,
  SET_ACK_CALL_REQUEST_INFORMATION,
  RESET_ACK_CALL_REQUEST_DIALOG,
  CLEAN_CURRENT_JOBS,
  BACKUP_CURRENT_PROTOCOL_JOBS,
  CLEAN_BACKUP_PROTOCOLS,
  DISABLED_JOB_ITEMS,
  ADD_CURRENT_PROTOCOL,
  SET_JOB_CHANNEL,
  SET_JOBS,
  SET_JOBS_PAGINATED,
  SET_ACK_CALL_REQUEST_IN_PROGRESS,
  SET_TRANSFER_ASSISTED_WAITING_CONFIRMATION,
} from '../../mutation-types';
import JobService, {
  getTransfers,
  fetchWhatsappPin,
  fetchWhatsappUnPin,
  fetchWhatsappRead,
  fetchWhatsappUnRead,
  transferAssistedAccept,
} from '@/services/job-service';
import { sendMessage } from '@/services/whatsapp-messages-service';
import { EventBus } from '@/event-bus';
import ContactService, { getMessageHistory } from '@/services/contact-service';
import { getQualificationByAlias } from '@/services/qualify-service';
import Message from '@/weon/models/Message';
import WhatsappService from '@/services/whatsapp-service';
import router from '@/router';
import moment from 'moment';

const findJobByProtocol = (protocol) => (job) =>
  job && job.protocol === protocol;

const actions = {
  setJobs({ commit }, jobs) {
    commit(SET_JOBS, jobs);
  },

  setJobsPaginated({ commit }, { jobs, push = false }) {
    commit(SET_JOBS_PAGINATED, { jobs, push });
  },

  addNewColumnContactColumns({ commit }, { column, protocol }) {
    commit(NEW_COLUMN_CONTACT_COLUMNS_JOB, { column, protocol });
  },

  addLastContact({ commit }, { lastContact, protocol }) {
    commit(ADD_LAST_CONTACT, { lastContact, protocol });
  },

  clearProtocol({ commit }) {
    commit(CLEAR_PROTOCOL);
  },

  clearContactHistory({ commit }, jobProtocol) {
    commit(CLEAR_CONTACT_HISTORY, jobProtocol);
  },

  navigation({ getters, commit }, job) {
    if (job.attendanceType == 'MANUAL' && getters.triggeredByAgent(job)) {
      commit(DELETE_MANUAL_ACTIVATION, job.contactIdentifier);
    }

    const channel = job.channel.toLowerCase();
    const isMessageChannelReceptive =
      (channel == 'whatsapp' || channel == 'chat') && !job.activeAttendance;
    if (isMessageChannelReceptive) return;

    router.push(`/attendance/${job.protocol}`);
    return;
  },

  addNewTagActiveJob({ commit }, tag) {
    commit(ADD_TAG_TAGS_ATTENDANCE, tag);
  },

  removeTagActiveJob({ commit }, tag) {
    commit(REMOVE_TAG_TAGS_ATTENDANCE, tag);
  },

  disabledJobItems({ commit }, value) {
    commit(DISABLED_JOB_ITEMS, value);
  },

  setActiveJob({ commit, state }, { protocol }) {
    commit(SET_ACTIVE_JOB, protocol);
    if (state.activeJob) {
      let job = state.jobList.find(findJobByProtocol(state.activeJob));
      const { channel } = job || {};
      if (channel && channel == 'voice') {
        commit(`jobs/${SET_JOB_CHANNEL}`, 'voice', { root: true });
        commit(`voice/${ADD_CURRENT_PROTOCOL}`, job, { root: true });
      }
    }
  },

  enableConversationTab({ commit }, { protocol }) {
    commit(ENABLE_CONVERSATION_TAB, protocol);
  },

  disableConversationTab({ commit }, { protocol }) {
    commit(DISABLE_CONVERSATION_TAB, protocol);
  },

  enableConversationOptions({ commit }) {
    commit(ENABLE_CONVERSATION_OPTIONS);
  },

  disableConversationOptions({ commit }) {
    commit(DISABLE_CONVERSATION_OPTIONS);
  },

  setTransferAssisted({ commit }, isTransfer) {
    commit(SET_TRANSFER_ASSISTED, isTransfer);
  },

  setTransferAssistedAccepted({ commit }, isTransferAccepted) {
    commit(SET_TRANSFER_ASSISTED_ACCEPTED, isTransferAccepted);
  },
  setTransferAssistedWaitingConfirmation(
    { commit },
    isTransferWaitingConfirmation,
  ) {
    commit(
      SET_TRANSFER_ASSISTED_WAITING_CONFIRMATION,
      isTransferWaitingConfirmation,
    );
  },
  setGupshupUserOptin({ commit }, user) {
    WhatsappService.setGupshupUserOptin(user).then();
  },

  sendWhatsAppMessage(
    { commit, dispatch },
    {
      protocol,
      message,
      isTemplateInfobip,
      idTemplateZenvia,
      fieldsZenvia,
      idTemplateInfobip,
      customFields,
    },
  ) {
    // const customId = Math.random().toString(36).substr(2, 10).toUpperCase()
    // const customIdSecondary = Math.random().toString(36).substr(2, 10).toUpperCase()
    const url =
      process.env.NODE_ENV == 'development'
        ? process.env.API_URL
        : window.CONFIG.weactionapi.url;
    let idPrim = message.idPrimary;
    let idSec = message.idSecondary;
    message.protocol = protocol;
    message.error = false;
    message.id = message.id;
    message.idPrimary = message.idPrimary;
    message.idSecondary = message.idSecondary;
    message.templateInfobip = isTemplateInfobip;
    message.idTemplateZenvia = idTemplateZenvia;
    message.idTemplateInfobip = idTemplateInfobip;
    message.fieldsZenvia = fieldsZenvia;
    message.customFields = { ...message.customFields, ...customFields };

    const messageToSave = JSON.parse(JSON.stringify(message));
    messageToSave.avatar = null;
    if (message.avatar) {
      messageToSave.avatar = url.slice(0, -1) + message.avatar;
    }

    commit(ADD_MESSAGE_TO_JOB, { protocol, message: messageToSave });

    const newMessage = JSON.parse(JSON.stringify(messageToSave));
    newMessage.agent_id = message.from;

    return sendMessage(message)
      .then((res) => {
        let id1 = res.data.message_id
          ? res.data.message_id.split('|')[0]
          : res.data.custom_id;
        let id2 = res.data.message_id
          ? res.data.message_id.split('|')[1]
          : res.data.custom_idSecondary;

        newMessage.idPrimary = id1;
        newMessage.idSecondary = id2;

        let a = id1;
        let b = id2;
        commit(UPDATE_MESSAGE_JOB_BY_CUSTOM_ID, {
          customId: a,
          customIdSecondary: b,
          idPrimary: idPrim,
          idSecondary: idSec,
          protocol,
          message: newMessage,
        });
      })
      .catch(() => {
        newMessage.error = true;
        dispatch(
          'showSnackbar',
          { text: 'Não foi possível enviar a mensagem', type: 'error' },
          { root: true },
        );
        let a = '';
        let b = '';
        commit(UPDATE_MESSAGE_JOB_BY_CUSTOM_ID, {
          customId: a,
          customIdSecondary: b,
          idPrimary: '',
          idSecondary: '',
          protocol,
          message: newMessage,
        });
      });
  },

  addNewMessage({ commit }, { message, protocol }) {
    const url =
      process.env.NODE_ENV == 'development'
        ? process.env.API_URL
        : window.CONFIG.weactionapi.url;

    const messageToSave = JSON.parse(JSON.stringify(message));
    messageToSave.avatar = null;

    if (message.avatar) {
      messageToSave.avatar = url.slice(0, -1) + message.avatar;
    }

    messageToSave.idPrimary = message.idPrimary;
    messageToSave.idSecondary = message.idSecondary;
    messageToSave.protocol = protocol;
    messageToSave.agent_id = message.agent_id;
    messageToSave.custom_id = message.idPrimary;
    messageToSave.custom_idSecondary = message.idSecondary;
    messageToSave.id = message.idPrimary;
    messageToSave.idSecondary = message.idSecondary;
    messageToSave.customFields = {
      idPrimary: messageToSave.idPrimary,
      idSecondary: messageToSave.idSecondary,
      ...message.customFields,
    };

    commit(ADD_MESSAGE_TO_JOB, { protocol, message: messageToSave });
  },

  closeWhatsApp({ dispatch }, informations) {
    return new Promise((resolve, reject) => {
      JobService.close(informations)
        .then(resolve)
        .catch((err) => {
          reject(err.message);
        });
    });
  },

  receiveWhatsAppMessage({ commit }, { protocol, message }) {
    commit(ADD_MESSAGE_TO_JOB_BY_PROTOCOL, {
      protocol,
      message,
    });
    commit(ENABLE_CONVERSATION_OPTIONS);
    commit(ENABLE_JOB_TEMPLATE_CONVERSATION, message.protocol);
  },

  reset({ commit }) {
    commit(RESET_JOBS);
  },

  getContactHistory({ commit, dispatch }, parameters) {
    return ContactService.getContactHistory(parameters).then((response) => {
      const history = response.data.length > 0 ? response.data.data : {};
      commit(SET_HISTORY_ACTIVE_JOB, history);
      dispatch('setParamsQueryHistory', response.data);

      const hasMore =
        response.data.per_page * response.data.current_page <
        response.data.total;

      return hasMore;
    });
  },

  setParamsQueryHistory({ commit }, responseHistory) {
    delete responseHistory.data;

    const commitParamsQuery = {
      newValue: responseHistory,
      property: 'paramsHistory',
    };

    commit(UPDATE_ACTIVE_JOB, commitParamsQuery);
  },

  getMessagesFromJob({ commit }, { protocol, groupProtocol }) {
    return JobService.getMessagesFromJob(protocol).then((res) => {
      const messages = [];
      res.data.forEach((message) => {
        messages.push(
          new Message({
            from: message.from,
            to: message.to,
            message: message.content.trim(),
            type: message.type,
            time: message.created_at,
          }),
        );
      });
      commit(SET_MESSAGES_FROM_HISTORY, {
        protocol,
        groupProtocol,
        messages,
      });
      return messages;
    });
  },

  setScriptJob({ commit }, { script, protocol }) {
    const paramUpdate = {
      property: 'script',
      value: script,
      protocol,
    };

    commit(UPDATE_JOB, paramUpdate);
    commit(FORCE_UPDATE_JOB, protocol);
  },

  setScriptActiveJob({ commit }, script) {
    commit(UPDATE_ACTIVE_JOB, { newValue: script, property: 'script' });
  },

  setFieldsScriptActiveJob({ commit }, fields) {
    commit(UPDATE_ACTIVE_JOB, {
      newValue: fields,
      property: 'scriptFields',
    });
  },

  updateContactActiveJob({ commit }, contact) {
    commit(UPDATE_ACTIVE_JOB, { newValue: contact, property: 'contact' });
  },

  updateContactColumnsActiveJob({ commit }, contactColumns) {
    commit(UPDATE_ACTIVE_JOB, {
      newValue: contactColumns,
      property: 'contactColumns',
    });
  },

  enableJob({ commit }, protocol) {
    commit(UPDATE_JOB, { value: false, property: 'disabled', protocol });
    commit(FORCE_UPDATE_JOB, protocol);
  },

  disableJob({ commit }, protocol) {
    commit(UPDATE_JOB, { value: true, property: 'disabled', protocol });
    commit(FORCE_UPDATE_JOB, protocol);
  },

  updateJob({ commit }, { protocol, property, value }) {
    commit(UPDATE_JOB, { value, property, protocol });
    commit(FORCE_UPDATE_JOB, protocol);
  },

  async setWhatsappPin({ commit }, { agent_id, protocol, pin }) {
    const setOrNotSet = pin ? fetchWhatsappPin : fetchWhatsappUnPin;
    try {
      await setOrNotSet(agent_id, protocol);
    } catch (err) {
      dispatch(
        'showSnackbar',
        { text: 'Não foi possível fixar o atendimento', type: 'error' },
        { root: true },
      );
    }
  },

  async setWhatsappUnread({ dispatch }, { agent_id, protocol, unread }) {
    const setOrNotSet = unread ? fetchWhatsappUnRead : fetchWhatsappRead;
    try {
      await setOrNotSet(agent_id, protocol);
      dispatch('updateJob', {
        property: 'unread',
        value: unread,
        protocol,
      });
    } catch (err) {
      dispatch(
        'showSnackbar',
        {
          text: 'Não foi possível marcar como não lida o atendimento',
          type: 'error',
        },
        { root: true },
      );
    }
  },

  async setWhatsappRead(
    { dispatch },
    { agent_id, protocol, unread, handleJobClick },
  ) {
    if (handleJobClick && unread === false) return;
    if (handleJobClick && unread === true) unread = false;
    const setOrNotSet = unread ? fetchWhatsappUnRead : fetchWhatsappRead;
    try {
      await setOrNotSet(agent_id, protocol);
      dispatch('updateJob', {
        property: 'unread',
        value: unread,
        protocol,
      });
    } catch (err) {
      // TODO: Se tiver desconectado canal de whatsapp, não é possível marcar como lida ou não lida
      dispatch(
        'showSnackbar',
        {
          text: `Não foi possível marcar como ${unread ? 'não lida' : 'lida'} o atendimento`,
          type: 'error',
        },
        { root: true },
      );
    }
  },

  disableActiveJob({ commit }) {
    commit(UPDATE_ACTIVE_JOB, { newValue: true, property: 'disabled' });
  },

  removeJob({ commit, dispatch }, protocol) {
    commit(REMOVE_JOB_FROM_LIST, protocol);
    dispatch('observation/clearObservation', protocol, { root: true });
  },

  removeActiveJob({ commit, state }) {
    const protocol = state.activeJob;
    commit(REMOVE_JOB_FROM_LIST, protocol);
  },

  newMessageNotRead({ commit }) {
    commit(NEW_MESSAGE_NOT_READ);
  },

  resetMessagesNotRead({ commit }) {
    commit(UPDATE_ACTIVE_JOB, {
      newValue: 0,
      property: 'messagesNotRead',
      event: 'resetMessagesNotRead',
    });
  },

  setScrollTopJob({ commit }, scrollTop) {
    commit(UPDATE_ACTIVE_JOB, {
      newValue: scrollTop,
      property: 'scrollTop',
    });
  },

  updateContactByProtocol({ commit }, { contact, protocol }) {
    if (!protocol) return;

    commit(UPDATE_JOB, { property: 'contact', value: contact, protocol });
    commit(FORCE_UPDATE_JOB, protocol);
  },

  updateJobWithErro({ commit }, { protocol }) {
    if (!protocol) return;

    commit(UPDATE_JOB, { property: 'error', value: true, protocol });
    commit(FORCE_UPDATE_JOB, protocol);
  },

  setValueScriptField({ commit }, field) {
    commit(ALTER_FIELD_SCRIPT, field);
  },

  async updateFieldsScripts({ dispatch }, { fields, protocol, channel }) {
    try {
      const fittingParam = { fields };

      await JobService.updateFieldsScript({
        fields: fittingParam,
        protocol,
        channel,
      });
    } catch (err) {
      window.console.error(err);
    }
  },

  updateStatusMessage({ commit }, informations) {
    commit(UPDATE_STATUS_MESSAGE, informations);
  },

  setNotificationsActiveJob({ commit }, notification) {
    commit(SET_NOTIFICATIONS_ACTIVEJOB, notification);
  },

  setStartDateQualifications({ commit, state }, startDate) {
    commit(UPDATE_ACTIVE_JOB, {
      newValue: startDate,
      property: 'startDateQualification',
    });

    EventBus.$emit('restart-time-job-protocol', state.activeJob);
  },

  updateVoiceActiveJob({ commit, getters }, protocol) {
    const job = getters.getJobByProtocol(protocol);

    const { channel } = job || {};

    if (channel && channel == 'voice') {
      commit(`voice/${ADD_CURRENT_PROTOCOL}`, job, { root: true });
    }
  },

  async showItemTab({ commit }, activeTab) {
    await commit(UPDATE_ACTIVE_JOB, {
      newValue: activeTab,
      property: 'activeTab',
      initiator: 'jobs/showItemTab',
    });
  },

  updateContactJob({ commit }, contact) {
    commit(UPDATE_JOB_CONTACT, { newValue: contact, property: 'contact' });
  },

  updateContactColumnsJob({ commit }, { contactColumns, contactId }) {
    commit(UPDATE_JOB_CONTACT_COLUMNS, {
      newValue: contactColumns,
      property: 'contactColumns',
      contactId,
    });
  },

  contactAndColumnsToJobs({ dispatch }, { contact, channel }) {
    dispatch('updateContactJob', contact);
    ContactService.getContactColumns(contact.id, channel).then((res) => {
      const contactData = { contactColumns: res.data, contactId: contact.id };
      dispatch('updateContactColumnsJob', contactData);
    });
  },

  updateTimeJobs({ commit }, times) {
    commit(SET_JOB_TIMES_INFORMATIONS_COMMUNICATOR, times);
  },

  updateTimesChannel({}, channelUpdate) {
    const param = {};
    param[channelUpdate.toLowerCase()] = true;

    EventBus.$emit('update-time-status', param);
  },

  addHistoryMessages({ commit }, { messages, protocol }) {
    if (messages)
      commit(ADD_MESSAGES_HISTORY_JOB, { protocol, messagesHistory: messages });
    commit(INCREMENT_PAGE_HISTORY_MESSAGE, protocol);
    commit(FORCE_UPDATE_JOB, protocol);
  },

  incrementPageHistoryMessages({ commit }, protocol) {},

  getMoreMessagesHistory({}, { page, contactIdentifierChannel }) {
    const param = {
      page,
      contactIdentifierChannel,
      initialDate: moment().format('YYYY-MM-DD HH:mm:ss'),
    };

    return getMessageHistory(param);
  },

  transfersByProtocol({}, protocol) {
    return getTransfers(protocol);
  },

  defaultContact({ dispatch }, { contacts, protocol }) {
    if (Array.isArray(contacts)) {
      dispatch(
        'contact/setContactsFound',
        { contacts, protocol },
        { root: true },
      );

      return { lastContact: null };
    }

    return { lastContact: null, ...contacts };
  },

  finishJob({ dispatch, getters, rootGetters }, protocol) {
    const job = getters.getJobByProtocol(protocol);
    const { disabled } = job || {};
    const channel = job.channel.toLowerCase();

    if (disabled) {
      if (channel === 'voice') {
        setTimeout(() => {
          dispatch('voice/resetVoiceStatus', null, { root: true });
        }, 100);
      }
      return;
    }

    const agent = rootGetters['attendance/attendance'];

    if (channel == 'whatsapp') {
      const informations = {
        agentId: agent.agentId,
        from: job.from,
        isTransfer: job.transferCount > 0,
        keepAlive: job.keepAlive ? job.keepAlive : false,
        mismatchError: job.error || job.waitingAnswer,
      };
      return dispatch('endWhatsApp', {
        informations,
        protocol,
      }).then(() => {
        dispatch('setStartDateQualifications', new Date());
        dispatch('updateTimesChannel', channel);
        dispatch('updateAgentStatusWhatsApp');
      });
    }

    if (channel == 'voice') {
      const call = {
        phone: job.phone,
        agentId: agent.agentId,
        protocol,
      };
      return dispatch('voice/hungUpCall', { call, protocol }, { root: true })
        .then(() => {
          dispatch('updateTimesChannel', channel);
          dispatch('updateAgentStatusVoice');
          dispatch('disableJob', job.protocol);
          dispatch('updateVoiceActiveJob', job.protocol);
          setTimeout(() => {
            dispatch('voice/resetVoiceStatus', null, { root: true });
          }, 100);
        })
        .catch(() => {
          dispatch('updateTimesChannel', channel);
          dispatch('updateAgentStatusVoice');
          setTimeout(() => {
            dispatch('voice/resetVoiceStatus', null, { root: true });
          }, 100);
        });
    }

    if (channel == 'chat') {
      const finishJob = {
        agentId: agent.agentId,
        chatUser: job.from,
      };

      return dispatch('endChat', { finishJob, protocol }).then(() => {
        dispatch('setStartDateQualifications', new Date());
        dispatch('updateTimesChannel', channel);
        dispatch('updateAgentStatusChat');
      });
    }

    console.log('Ainda não foi implementado para este canal de atendimento');
    return;
  },

  automaticEmptyQualify({ dispatch }, protocol) {
    return getQualificationByAlias('unqualified').then((qualify) => {
      const informations = {
        protocol,
        qualify,
        qualifyPath: qualify.name,
      };
      return dispatch('qualifyJob', informations);
    });
  },

  qualifyJob(
    { getters, dispatch, rootGetters },
    { protocol, qualify, qualifyPath, inbox },
  ) {
    const job = getters.getJobByProtocol(protocol);
    const { channel } = job || {};

    const tags = JSON.parse(JSON.stringify(job.tags));
    let fieldsForm = null;

    const agent = rootGetters['attendance/attendance'];
    const uniqueId = (job) => {
      if (channel.toLowerCase() != 'whatsapp') return job.uniqueId;
      if (job.transferCount > 0) return job.fatherId;
      return job.whatsAppId === '' ? job.fatherId : job.whatsAppId;
    };

    const observation = rootGetters['observation/getObservation'](protocol);

    const jobFinished = getters.getJobByProtocol(protocol);
    if (jobFinished.fiedlsScriptAltered !== undefined) {
      fieldsForm = jobFinished.fiedlsScriptAltered;
    }

    const durationQualification = (startDate) => {
      if (startDate) {
        return Math.round((new Date().getTime() - startDate.getTime()) / 1000);
      } else {
        return 0;
      }
    };

    const informations = {
      protocol,
      qualify_id: qualify.id,
      agent_id: agent.agentId,
      qualify_path: qualifyPath || qualify.name,
      uniqueid: uniqueId(job),
      contact: job.contact,
      agent_name: agent.agentName,
      queue: !job.activeAttendance ? job.queue : null,
      campaign: job.activeAttendance ? job.campaign : null,
      tags,
      observation,
      duration: durationQualification(job.startDateQualification),
      channel: channel.toLowerCase(),
      qualify_type: qualify.type,
      finish_qualification: qualify.finish_dialing,
      attendance_type:
        channel.toLowerCase() == 'voice' ? job.callType : job.attendance_type,
      client_whatsapp: channel.toLowerCase() == 'whatsapp' ? job.from : null,
      contact_identifier:
        channel.toLowerCase() == 'chat' ? job.contactIdentifier : null,
      client_chat: channel.toLowerCase() == 'chat' ? job.from : null,
      from: channel.toLowerCase() == 'chat' ? job.from : null,
      phone: channel.toLowerCase() == 'voice' ? job.phone : null,
      finish_dialing: qualify.finish_dialing,
      schedule: job.activeAttendance && job.schedule ? job.schedule : null,
      fields_form: fieldsForm,
      inbox: inbox || false,
      attendanceGroupId: job.attendanceGroupId,
      attendanceGroupName: job.attendanceGroupName,
    };

    if (channel.toLowerCase() == 'whatsapp') {
      return dispatch('whatsappQualify', informations).then(() => {
        return dispatch('closeWhatsApp', {
          agentId: agent.agentId,
          from: job.from,
          fatherId: job.fatherId,
        }).then(() => {
          dispatch('removeJob', protocol);
          dispatch('qualify/reset', null, { root: true });
        });
      });
    }

    if (channel.toLowerCase() == 'voice') {
      return dispatch('voiceQualify', informations).then(() => {
        dispatch('removeJob', protocol);
        dispatch('qualify/reset', null, { root: true });
      });
    }

    if (channel.toLowerCase() == 'chat') {
      return dispatch('chatQualify', informations).then(() => {
        return dispatch('closeChat', {
          agentId: agent.agentId,
          chatUser: job.from,
          fatherId: job.fatherId,
        }).then(() => {
          dispatch('removeJob', protocol);
          dispatch('qualify/reset', null, { root: true });
        });
      });
    }

    console.log('A qualificação para este canal ainda não foi implementada');
    return;
  },
  setKeepAlive({ commit }, protocol) {
    commit(SET_WHATSAPP_KEEP_ALIVE, protocol);
  },
  newWhatsAppMessageNotification({ commit }, newNotification) {
    commit(SET_NEW_WHATSAPP_MESSAGE_NOTIFICATION, newNotification);
  },
  disableJobTemplateConversation({ commit }, protocol) {
    commit(DISABLE_JOB_TEMPLATE_CONVERSATION, protocol);
  },
  templateSent({ commit }, { protocol }) {
    commit(SET_WHATSAPP_TEMPLATE_SENT, protocol);
  },
  ackCallRequestShowDialog({ commit }, status) {
    commit(SET_ACK_CALL_REQUEST_DIALOG, status);
  },
  ackCallRequestSetInformation({ commit }, callInformation) {
    commit(SET_ACK_CALL_REQUEST_INFORMATION, callInformation);
  },
  ackCallRequestResetDialog({ commit }) {
    commit(RESET_ACK_CALL_REQUEST_DIALOG);
  },
  postAckCalls(_, callInformation) {
    return JobService.postAckCallRequest(callInformation);
  },
  backupCurrentProtocolJobs({ commit }, channel) {
    commit(BACKUP_CURRENT_PROTOCOL_JOBS, channel);
  },
  cleanCurrentJobs({ commit }, channel) {
    commit(CLEAN_CURRENT_JOBS, channel);
  },
  async cleanProtocolBackup({ commit }, protocol) {
    await commit(CLEAN_BACKUP_PROTOCOLS, protocol);
  },
  recoverJobsFromBackupProtocol({ dispatch, rootState }) {
    const agentId = rootState.attendance.Attendance.agentId;
    rootState.jobs.backupProtocols.forEach((protocol) => {
      dispatch('addInboxInProccess', protocol);
      dispatch('whatsappReopen', {
        protocol,
        agent_id: agentId,
        silent: true,
      });
    });

    dispatch('_connection/showConnectionProblemDialog', false, { root: true });
    dispatch('_connection/setReconnectionConfirmation', false, { root: true });
  },
  setLastMessage({ commit }, { protocol, message }) {
    commit('SET_LAST_MESSAGE', { protocol, message });
  },
  setAckCallRequestInProgress({ commit }, status) {
    commit(SET_ACK_CALL_REQUEST_IN_PROGRESS, status);
  },
};

export default actions;
